<ng-template #materialApoioTemplate>
  <b>Para que serve a opção de importação de dados?</b>
  <p>
    A importação de arquivo é uma funcionalidade que permite incluir ou atualizar, de forma prática e eficiente, os
    dados dos colaboradores e seus respectivos benefícios. Por meio dessa opção, é possível carregar informações
    diretamente de um arquivo, como:
  </p>

  <ul>
    <li>Dados da empresa;</li>
    <li>Informações cadastrais dos funcionários;</li>
    <li>Detalhes sobre os benefícios vinculados a cada colaborador.</li>
  </ul>

  <p>
    Essa funcionalidade é especialmente útil quando há um grande volume de funcionários, pois evita a necessidade de
    realizar cadastros ou atualizações manualmente, economizando tempo e reduzindo erros operacionais.
  </p>
  <b>Qual tipo de importação devo escolher?</b>
  <p>
    Existem duas opções de importação de dados disponíveis, e a escolha depende da estrutura que você já possui em seu
    sistema de folha de pagamento:
  </p>
  <b> Importação do tipo APB (Arquivo Padrão de Benefícios): </b>
  <p>
    Indicada para empresas que já possuem esse layout configurado em seu sistema de folha de pagamento. Essa opção
    permite uma integração mais direta e automatizada, aproveitando o padrão já existente.
  </p>
  <b> Importação do tipo CSV: </b>
  <p>
    Recomendada para quem não possui o layout APB configurado. É uma alternativa mais simples e flexível, que pode ser
    montada manualmente com facilidade, sem a necessidade de um software de folha de pagamento. Ideal para ajustes
    rápidos ou para empresas que estão iniciando o processo de digitalização dos dados.
  </p>

  <b> Download de materiais de apoio </b>
  <div class="mt-3 mb-3">
    <div
      (click)="manualPadrao()"
      class="mb-2 cartao cartao-relatorios p-3 border border-principal rounded-16 d-flex align-items-center justify-content-between"
    >
      Manual de importação APB (Arquivo Padrão de Benefícios)
      <div><mat-icon iconPositionEnd svgIcon="download-vermelho"></mat-icon></div>
    </div>
    <div
      (click)="manualCSV()"
      class="cartao cartao-relatorios p-3 border border-principal rounded-16 d-flex align-items-center justify-content-between"
    >
      Manual de importação CSV
      <div><mat-icon iconPositionEnd svgIcon="download-vermelho"></mat-icon></div>
    </div>
  </div>
</ng-template>

<div class="row mt-16">
  <div *ngIf="!isCaixa" class="col-lg-12 text-end mb-16">
    <a
      href="#"
      class="font-size-14 d-flex align-items-center justify-content-end gap-1"
      (click)="openMaterialApoioDialog(); $event.preventDefault()"
    >
      Material de apoio
      <mat-icon svgIcon="info-current"></mat-icon>
    </a>
  </div>
  <!-- importacao padrao -->
  <div *ngIf="!isCaixa" class="col-xxl-4 col-lg-6">
    <spe-cartao-simples
      titulo="Importação de arquivo APB"
      subtitulo="Atualiza todos os funcionários do portal"
      [icone]="
        sigla === 'CAIXA'
          ? '/assets/img/icons/importacao/azul/importacao-padrao.svg'
          : '/assets/img/icons/importacao/vermelho/importacao-padrao.svg'
      "
      numero="0"
      rota="/home/importacao/importar-arquivo/padrao"
    ></spe-cartao-simples>
  </div>

  <!-- importacao de arquivo csv -->
  <div class="col-xxl-4 col-lg-6">
    <spe-cartao-simples
      titulo="Importação de arquivo CSV"
      subtitulo="Atualiza todos os funcionários do portal"
      icone="/assets/img/icons/importacao/importacao-de-arquivo-csv.svg"
      [icone]="
        sigla === 'CAIXA'
          ? '/assets/img/icons/importacao/azul/importacao-de-arquivo-csv.svg'
          : '/assets/img/icons/importacao/vermelho/importacao-de-arquivo-csv.svg'
      "
      numero="0"
      rota="/home/importacao/importar-arquivo/csv"
    ></spe-cartao-simples>
  </div>

  <!-- importacao de arquivo csv personalizado -->
  <div class="col-xxl-4 col-lg-6" *ngIf="accessService.isBetaTesterUser()">
    <spe-cartao-simples
      titulo="Importação de arquivo CSV personalizado"
      subtitulo="Atualiza todos os funcionários do portal"
      icone="/assets/img/icons/importacao/importacao-de-arquivo-csv.svg"
      [icone]="
        sigla === 'CAIXA'
          ? '/assets/img/icons/importacao/azul/importacao-personalizada.svg'
          : '/assets/img/icons/importacao/vermelho/importacao-personalizada.svg'
      "
      numero="0"
      [isNew]="true"
      rota="/home/importacao/importar-arquivo/csv-personalizado"
    ></spe-cartao-simples>
  </div>

  <!-- importacao personalizada -->
  <!-- SOLICITADO COMENTAR O TRECHO A PEDIDO DE GAUTIERY -->
  <!-- <div class="col-xxl-4 col-xl-6">
    <spe-cartao-simples
      *ngIf="!isCaixa"
      titulo="Importação personalizada"
      subtitulo="Atualiza as informações dos produtos no arquivo"
      icone="/assets/img/icons/importacao/importacao-personalizada.svg"
      [icone]="sigla === 'CAIXA' ? '/assets/img/icons/importacao/azul/importacao-personalizada.svg' : '/assets/img/icons/importacao/vermelho/importacao-personalizada.svg'"
      numero="0"
      rota="/home/importacao/importar-arquivo/personalizada"
    ></spe-cartao-simples>
  </div> -->
</div>
